import * as $ from "jquery";
import { DarkOverlay } from "Components/DarkOverlay";
import { on, onChange, onClick, onClickOutsideOf, onLoad } from "Core/Events";
import { SliderTypeFilters } from "Components/Filters/SliderTypeFilters";
import { SelectTypeFilters } from "Components/Filters/SelectTypeFilters";
import { MultiselectTypeFilters } from "Components/Filters/MultiselectTypeFilters";
import { SubmittableFilter } from "Components/Filters/SubmittableFilter";

export class Filters {
  public static readonly Selector = {
    FILTER_FORM: ".js_filter_form",
    FILTER_SELECTS: ".filter-selects",
    EXTRA_FILTER_SORT_SELECTS: '#srt_1, #srt_2',
    SHOW_MORE_FILTERS_BTN: ".js_filters_showMoreFiltersBtn",
    HIDE_MORE_FILTERS_BTN: ".js_filters_hideMoreFiltersBtn",
    MORE_FILTERS_SIDE_SECTION: ".js_filters_moreFiltersSideSection",
    FILTER_SLIDER_ITEM: ".js_filter_slider_item",
    SLIDER_ITSELF: ".js_filter_slider",
    APPLY_FILTERS_BTN: ".js_applyFilters_btn",
    DELETE_FILTER_BTN: '.js_delete_filter_btn',
    DELETE_ALL_FILTERS_BTN: '.js_delete_all_filters_btn ',
    PAGE: '.js_filter_form button.page-link',
    NORMAL_FILTERS_SECTION: '.js_normal_filters_section'
  };

  private static urlGetDataMap = new Map();
  private static readonly PageFilter = 'page';
  private static readonly OnPageFilter = 'on_page';

  @onLoad(() => MultiselectTypeFilters.init())
  @onLoad(() => SelectTypeFilters.init())
  @onLoad(() => SliderTypeFilters.init())
  @onLoad(() => Filters.initMutualExclusion())
  @onClick(Filters.Selector.APPLY_FILTERS_BTN, (event) => Filters.applyBasicFiltersAndSubmit(event))
  @onClick(Filters.Selector.APPLY_FILTERS_BTN, (event) => Filters.applyBasicFiltersAndSubmit(event))
  @onChange(
    Filters.Selector.FILTER_SELECTS,
    (event) => Filters.markSelectAsReadyToBeSubmitted(event)
  )
  @onClick(
    Filters.Selector.SHOW_MORE_FILTERS_BTN,
    () => Filters.toggleMoreFiltersSectionVisibility(true)
  )
  @onClick(
    Filters.Selector.HIDE_MORE_FILTERS_BTN,
    () => Filters.toggleMoreFiltersSectionVisibility(false)
  )
  @onClickOutsideOf(
    Filters.Selector.MORE_FILTERS_SIDE_SECTION,
    () => Filters.toggleMoreFiltersSectionVisibility(false)
  )
  @onClick(Filters.Selector.PAGE, (event) => Filters.applyPageToFilter(event))
  @on('selectricChangeFilters', (event, data) => Filters.applyExtraFiltersFromSortSelects(event, data))

  @onClick(Filters.Selector.DELETE_FILTER_BTN, (event) => Filters.deleteFilter(event))
  @onClick(Filters.Selector.DELETE_ALL_FILTERS_BTN, (event) => Filters.deleteAllFilters(event))

  public static toggleMoreFiltersSectionVisibility(visible: boolean) {
    const hiddenClass = "hidden";

    if (visible) {
      DarkOverlay.show();
      $(this.Selector.MORE_FILTERS_SIDE_SECTION).removeClass(hiddenClass);
    } else {
      DarkOverlay.hide();
      $(this.Selector.MORE_FILTERS_SIDE_SECTION).addClass(hiddenClass);
    }
  }

  /**
   * Basic setting of filters on the form
   */
  public static applyBasicFiltersAndSubmit(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.submit();
  }

  /**
   * Only for changes extra select on form - on_page and page
   */
  public static applyExtraFiltersFromSortSelects(event, data) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.collectExtraSortFilters();
    Filters.submit();
  }

  /**
   * Only for navigating between category subpages.
   */
  public static applyPageToFilter(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.collectExtraSortFilters();
    let pageButton = $(event.currentTarget);
    let pageButtonValue = pageButton.val() as number;
    if (pageButtonValue > 1) {
      Filters.urlGetDataMap.set(Filters.PageFilter, pageButtonValue);
    } else {
      Filters.urlGetDataMap.delete(Filters.PageFilter);
    }
    Filters.submit();
  }

  /**
   * Delete all filters and redirect to clear url
   */
  public static deleteAllFilters(event: JQuery.Event) {
    event.preventDefault();
    this.redirect(this.getCurrentLocation());
  }

  /**
   * Extensive method to remove filters from url.
   * Consult with Bartek before modifying.
   */
  public static deleteFilter(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();

    let button = $(event.target).parents(this.Selector.DELETE_FILTER_BTN);
    let filterName = button.data('delete-filter-name');
    let filterValue = button.val() as string;
    let filterNameWithBlankValue = filterName + "[]";
    let filterNameWithValue = button.data('delete-filter-name-with-value');

    if (Filters.urlGetDataMap.has(filterNameWithBlankValue)) {
      let FilterAllValues = Filters.urlGetDataMap.get(filterNameWithBlankValue);
      if (typeof FilterAllValues === "object") {
        //remove value from multiselect - color for example
        delete FilterAllValues[filterValue];
        Filters.urlGetDataMap.delete(filterNameWithBlankValue);
        let valuesArray = Object.values(FilterAllValues);
        Filters.urlGetDataMap.set(filterNameWithBlankValue, valuesArray);
      } else if (typeof FilterAllValues === "string") {
        //remove value from select - width, height, length for example
        Filters.urlGetDataMap.delete(filterNameWithBlankValue);
      }
    }
    if (Filters.urlGetDataMap.has(filterNameWithValue)) {
      Filters.urlGetDataMap.delete(filterNameWithValue);
    }
    if (Filters.urlGetDataMap.has(filterName)) {
      Filters.urlGetDataMap.delete(filterName);
    }
    Filters.removePageNumberFromFilters();
    Filters.submit();
  }

  /**
   * Collect all active filters
   */
  private static collectReadyToSubmitFilters() {
    let inputsWithValuesToSubmit = $(
      `${this.Selector.FILTER_FORM} input[type=text][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=number][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=hidden][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=checkbox][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} select[name].${SubmittableFilter.readyToBeSubmittedClass}`
    );

    inputsWithValuesToSubmit.each((index, element) => {
      let name = $(element).attr("name");
      let value = $(element).val();

      if (name) {
        Filters.urlGetDataMap.set(name, value);
      }
    });
  }

  /**
   * Collect extra data to filters, on_page and page
   */
  private static collectExtraSortFilters() {
    $(this.Selector.EXTRA_FILTER_SORT_SELECTS).each((index, select) => {
      if ($(select).val() !== null && $(select).val() !== "") {
        let option = ($(select).find('option:selected'));
        if (option.data('default') !== true) {
          Filters.urlGetDataMap.set($(select).attr('name'), $(select).val());
          if ($(select).attr('name') === Filters.OnPageFilter) {
            Filters.removePageNumberFromFilters();
          }
        } else {
          Filters.urlGetDataMap.delete($(select).attr('name'));
        }
      }
    });
  }

  /**
   * Remove 'page' from filters
   */
  private static removePageNumberFromFilters() {
    Filters.urlGetDataMap.delete(Filters.PageFilter);
  }


  public static markSelectAsReadyToBeSubmitted(event: JQuery.Event) {
    let select = $(event.target);
    let selectedOption = select.find(":selected");
    let name = select.attr("name");
    if (name && selectedOption.val()) {
      select.addClass(SubmittableFilter.readyToBeSubmittedClass);
    } else {
      select.removeClass(SubmittableFilter.readyToBeSubmittedClass);
    }
  }

  /**
   * Return current page location
   */
  private static getCurrentLocation() {
    let location = window.location.origin + window.location.pathname;
    if (location.charAt(location.length - 1) !== "/") {
      location += "/";
    }

    return location;
  }

  /**
   * Submit form to new page with set filters
   */
  public static submit() {
    let queryString = $.param(Object.fromEntries(Filters.urlGetDataMap));
    let newUrl = this.getCurrentLocation();
    if (queryString !== "") {
      newUrl += "?" + queryString;
    }
    this.redirect(newUrl);
  }

  /**
   * Redirect to new location
   */
  private static redirect(newUrl: string) {
    window.location.href = newUrl;
  }

  /**
   * Ensures that for scalar filters (not ending in []), only the most recently changed input
   * retains the ready-to-submit status. This prevents conflicts between duplicate filters
   * (e.g. in normal vs side sections).
   */
  private static initMutualExclusion() {
    $(document).on('change', Filters.Selector.FILTER_FORM + ' :input', (event) => {
      const changedInput = $(event.currentTarget as unknown as HTMLElement);
      const name = changedInput.attr('name');

      // Ignore if no name or if it's an array filter (e.g. color[])
      if (!name || name.endsWith('[]')) {
        return;
      }

      // Find all other inputs with the same name that are currently marked as ready
      // We look inside the form(s) to be safe
      const otherReadyInputs = $(`${Filters.Selector.FILTER_FORM} [name="${name}"].${SubmittableFilter.readyToBeSubmittedClass}`).not(changedInput);

      // Remove the class from them
      otherReadyInputs.removeClass(SubmittableFilter.readyToBeSubmittedClass);
    });
  }
}
import * as $ from "jquery";
import { DarkOverlay } from "Components/DarkOverlay";
import { on, onChange, onClick, onClickOutsideOf, onLoad } from "Core/Events";
import { SliderTypeFilters } from "Components/Filters/SliderTypeFilters";
import { SelectTypeFilters } from "Components/Filters/SelectTypeFilters";
import { MultiselectTypeFilters } from "Components/Filters/MultiselectTypeFilters";
import { SubmittableFilter } from "Components/Filters/SubmittableFilter";

export class Filters {
  public static readonly Selector = {
    FILTER_FORM: ".js_filter_form",
    FILTER_SELECTS: ".filter-selects",
    EXTRA_FILTER_SORT_SELECTS: '#srt_1, #srt_2',
    SHOW_MORE_FILTERS_BTN: ".js_filters_showMoreFiltersBtn",
    HIDE_MORE_FILTERS_BTN: ".js_filters_hideMoreFiltersBtn",
    MORE_FILTERS_SIDE_SECTION: ".js_filters_moreFiltersSideSection",
    FILTER_SLIDER_ITEM: ".js_filter_slider_item",
    SLIDER_ITSELF: ".js_filter_slider",
    APPLY_FILTERS_BTN: ".js_applyFilters_btn",
    DELETE_FILTER_BTN: '.js_delete_filter_btn',
    DELETE_ALL_FILTERS_BTN: '.js_delete_all_filters_btn ',
    PAGE: '.js_filter_form button.page-link',
    NORMAL_FILTERS_SECTION: '.js_normal_filters_section'
  };

  private static urlGetDataMap = new Map();
  private static readonly PageFilter = 'page';
  private static readonly OnPageFilter = 'on_page';

  @onLoad(() => MultiselectTypeFilters.init())
  @onLoad(() => SelectTypeFilters.init())
  @onLoad(() => SliderTypeFilters.init())
  @onLoad(() => Filters.initMutualExclusion())
  @onClick(Filters.Selector.APPLY_FILTERS_BTN, (event) => Filters.applyBasicFiltersAndSubmit(event))
  @onClick(Filters.Selector.APPLY_FILTERS_BTN, (event) => Filters.applyBasicFiltersAndSubmit(event))
  @onChange(
    Filters.Selector.FILTER_SELECTS,
    (event) => Filters.markSelectAsReadyToBeSubmitted(event)
  )
  @onClick(
    Filters.Selector.SHOW_MORE_FILTERS_BTN,
    () => Filters.toggleMoreFiltersSectionVisibility(true)
  )
  @onClick(
    Filters.Selector.HIDE_MORE_FILTERS_BTN,
    () => Filters.toggleMoreFiltersSectionVisibility(false)
  )
  @onClickOutsideOf(
    Filters.Selector.MORE_FILTERS_SIDE_SECTION,
    () => Filters.toggleMoreFiltersSectionVisibility(false)
  )
  @onClick(Filters.Selector.PAGE, (event) => Filters.applyPageToFilter(event))
  @on('selectricChangeFilters', (event, data) => Filters.applyExtraFiltersFromSortSelects(event, data))

  @onClick(Filters.Selector.DELETE_FILTER_BTN, (event) => Filters.deleteFilter(event))
  @onClick(Filters.Selector.DELETE_ALL_FILTERS_BTN, (event) => Filters.deleteAllFilters(event))

  public static toggleMoreFiltersSectionVisibility(visible: boolean) {
    const hiddenClass = "hidden";

    if (visible) {
      DarkOverlay.show();
      $(this.Selector.MORE_FILTERS_SIDE_SECTION).removeClass(hiddenClass);
    } else {
      DarkOverlay.hide();
      $(this.Selector.MORE_FILTERS_SIDE_SECTION).addClass(hiddenClass);
    }
  }

  /**
   * Basic setting of filters on the form
   */
  public static applyBasicFiltersAndSubmit(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.submit();
  }

  /**
   * Only for changes extra select on form - on_page and page
   */
  public static applyExtraFiltersFromSortSelects(event, data) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.collectExtraSortFilters();
    Filters.submit();
  }

  /**
   * Only for navigating between category subpages.
   */
  public static applyPageToFilter(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();
    Filters.collectExtraSortFilters();
    let pageButton = $(event.currentTarget);
    let pageButtonValue = pageButton.val() as number;
    if (pageButtonValue > 1) {
      Filters.urlGetDataMap.set(Filters.PageFilter, pageButtonValue);
    } else {
      Filters.urlGetDataMap.delete(Filters.PageFilter);
    }
    Filters.submit();
  }

  /**
   * Delete all filters and redirect to clear url
   */
  public static deleteAllFilters(event: JQuery.Event) {
    event.preventDefault();
    this.redirect(this.getCurrentLocation());
  }

  /**
   * Extensive method to remove filters from url.
   * Consult with Bartek before modifying.
   */
  public static deleteFilter(event: JQuery.Event) {
    event.preventDefault();
    Filters.collectReadyToSubmitFilters();

    let button = $(event.target).parents(this.Selector.DELETE_FILTER_BTN);
    let filterName = button.data('delete-filter-name');
    let filterValue = button.val() as string;
    let filterNameWithBlankValue = filterName + "[]";
    let filterNameWithValue = button.data('delete-filter-name-with-value');

    if (Filters.urlGetDataMap.has(filterNameWithBlankValue)) {
      let FilterAllValues = Filters.urlGetDataMap.get(filterNameWithBlankValue);
      if (typeof FilterAllValues === "object") {
        //remove value from multiselect - color for example
        delete FilterAllValues[filterValue];
        Filters.urlGetDataMap.delete(filterNameWithBlankValue);
        let valuesArray = Object.values(FilterAllValues);
        Filters.urlGetDataMap.set(filterNameWithBlankValue, valuesArray);
      } else if (typeof FilterAllValues === "string") {
        //remove value from select - width, height, length for example
        Filters.urlGetDataMap.delete(filterNameWithBlankValue);
      }
    }
    if (Filters.urlGetDataMap.has(filterNameWithValue)) {
      Filters.urlGetDataMap.delete(filterNameWithValue);
    }
    if (Filters.urlGetDataMap.has(filterName)) {
      Filters.urlGetDataMap.delete(filterName);
    }
    Filters.removePageNumberFromFilters();
    Filters.submit();
  }

  /**
   * Collect all active filters
   */
  private static collectReadyToSubmitFilters() {
    let inputsWithValuesToSubmit = $(
      `${this.Selector.FILTER_FORM} input[type=text][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=number][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=hidden][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} input[type=checkbox][name].${SubmittableFilter.readyToBeSubmittedClass}, 
       ${this.Selector.FILTER_FORM} select[name].${SubmittableFilter.readyToBeSubmittedClass}`
    );

    inputsWithValuesToSubmit.each((index, element) => {
      let name = $(element).attr("name");
      let value = $(element).val();

      if (name) {
        Filters.urlGetDataMap.set(name, value);
      }
    });
  }

  /**
   * Collect extra data to filters, on_page and page
   */
  private static collectExtraSortFilters() {
    $(this.Selector.EXTRA_FILTER_SORT_SELECTS).each((index, select) => {
      if ($(select).val() !== null && $(select).val() !== "") {
        let option = ($(select).find('option:selected'));
        if (option.data('default') !== true) {
          Filters.urlGetDataMap.set($(select).attr('name'), $(select).val());
          if ($(select).attr('name') === Filters.OnPageFilter) {
            Filters.removePageNumberFromFilters();
          }
        } else {
          Filters.urlGetDataMap.delete($(select).attr('name'));
        }
      }
    });
  }

  /**
   * Remove 'page' from filters
   */
  private static removePageNumberFromFilters() {
    Filters.urlGetDataMap.delete(Filters.PageFilter);
  }


  public static markSelectAsReadyToBeSubmitted(event: JQuery.Event) {
    let select = $(event.target);
    let selectedOption = select.find(":selected");
    let name = select.attr("name");
    if (name && selectedOption.val()) {
      select.addClass(SubmittableFilter.readyToBeSubmittedClass);
    } else {
      select.removeClass(SubmittableFilter.readyToBeSubmittedClass);
    }
  }

  /**
   * Return current page location
   */
  private static getCurrentLocation() {
    let location = window.location.origin + window.location.pathname;
    if (location.charAt(location.length - 1) !== "/") {
      location += "/";
    }

    return location;
  }

  /**
   * Submit form to new page with set filters
   */
  public static submit() {
    let queryString = $.param(Object.fromEntries(Filters.urlGetDataMap));
    let newUrl = this.getCurrentLocation();
    if (queryString !== "") {
      newUrl += "?" + queryString;
    }
    this.redirect(newUrl);
  }

  /**
   * Redirect to new location
   */
  private static redirect(newUrl: string) {
    window.location.href = newUrl;
  }

  /**
   * Ensures that for scalar filters (not ending in []), only the most recently changed input
   * retains the ready-to-submit status. This prevents conflicts between duplicate filters
   * (e.g. in normal vs side sections).
   */
  private static initMutualExclusion() {
    $(document).on('change', Filters.Selector.FILTER_FORM + ' :input', (event) => {
      const changedInput = $(event.currentTarget as unknown as HTMLElement);
      const name = changedInput.attr('name');

      // Ignore if no name or if it's an array filter (e.g. color[])
      if (!name || name.endsWith('[]')) {
        return;
      }

      // Find all other inputs with the same name that are currently marked as ready
      // We look inside the form(s) to be safe
      const otherReadyInputs = $(`${Filters.Selector.FILTER_FORM} [name="${name}"].${SubmittableFilter.readyToBeSubmittedClass}`).not(changedInput);

      // Remove the class from them
      otherReadyInputs.removeClass(SubmittableFilter.readyToBeSubmittedClass);
    });
  }
}
